<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="企业名称">
              <a-input placeholder="请输入企业名称" v-model="queryParam.corpName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="联系人">
              <a-input placeholder="请输入联系人" v-model="queryParam.contact"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="激活状态">
              <j-multi-select-tag
                :options="[{
                    label: '已激活',
                    value: '1'
                    },{
                    label: '未激活',
                    value: '0'
                    }]"
                @change="searchQuery"
                placeholder="激活状态"
                type="checkbox"
                v-model="queryParam.activated"
              />
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('智能加水机消费企业')" icon="download" type="primary">导出</a-button>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>
      <!-- :customRow="customRowRender"设置双击详情、自定义单击事件 -->
      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <span slot="activatedSlot" slot-scope="text, record">
          <a-tag color="#52c41a" v-if="record.activated == 1">已激活</a-tag>
          <a-tag color="#ff4d4f" v-else>未激活</a-tag>
        </span>

        <template slot="remainSlot" slot-scope="text, record">
          <!-- 先付后用才显示余量 -->
          <template v-if="record.payStrategy == 1">
            <a-tag color="#52c41a" v-if="record.remainingVolume > 20">{{record.remainingVolume}}吨</a-tag>

            <a-tooltip title="余额不足，请提醒用户及时充水量" v-else>
              <a-tag color="#ff4d4f">{{record.remainingVolume || 0}}吨</a-tag>
            </a-tooltip>
          </template>
          <a-tag v-else>--</a-tag>
        </template>

        <a-switch
          :checked="!!record.disabled"
          @change="handleDisabled(record.id, !record.disabled ? 1 : 0)"
          checked-children="禁止"
          slot="disabled"
          slot-scope="text, record"
        />

        <a-switch
          :checked="!!record.maintenancePermission"
          @change="handleMaintenancePermission(record.id, !record.maintenancePermission ? 1 : 0)"
          checked-children="是"
          slot="maintenancePermission"
          slot-scope="text, record"
        />

        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
        </template>

        <template slot="files" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button
            :key="index"
            @click="previewFile(file.filePath)"
            size="small"
            type="link"
            v-else
            v-for="(file, index) in JSON.parse(text)"
          >
            {{
            file.fileName
            }}
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="recharge(record)">充水量</a>
          <a-divider type="vertical" />
          <a @click="authDev(record)">授权设备</a>
          <a-divider type="vertical" />
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="initAdmin(record)">初始化</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <wf-consumer-corp-modal @ok="modalFormOk" ref="modalForm"></wf-consumer-corp-modal>
    <wf-consumer-corp-recharge-modal @ok="modalFormOk" ref="rechargeModalForm"></wf-consumer-corp-recharge-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { putAction } from '@/api/manage'
  import WfConsumerCorpModal from './modules/WfConsumerCorpModal'
  import WfConsumerCorpRechargeModal from './modules/WfConsumerCorpRechargeModal'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'WfConsumerCorpList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
      WfConsumerCorpModal,
      WfConsumerCorpRechargeModal,
    },
    data () {
      return {
        description: '智能加水机消费企业管理页面',
        ipagination: {
          pageSize: 30,
        },
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '企业名称',
            align: "center",
            sorter: true,
            dataIndex: 'corpName'
          },
          {
            title: '联系人',
            align: "center",
            sorter: true,
            dataIndex: 'contact'
          },
          {
            title: '联系电话',
            align: "center",
            sorter: true,
            dataIndex: 'phone'
          },
          //   {
          //     title: '合同用水量(吨)',
          //     align: "center",
          //     sorter: true,
          //     dataIndex: 'contractVolume'
          //   },
          //   {
          //     title: '合同周期',
          //     align: "center",
          //     dataIndex: 'contractCycle'
          //   },
          {
            title: '剩余可用量',
            align: "center",
            sorter: true,
            dataIndex: 'remainingVolume',
            scopedSlots: { customRender: 'remainSlot' },
          },
          {
            title: '支付方式',
            align: "center",
            sorter: true,
            dataIndex: 'payStrategy_dictText'
          },
          {
            title: '是否激活',
            align: "center",
            sorter: true,
            dataIndex: 'activated',
            scopedSlots: { customRender: 'activatedSlot' },
          },
          {
            title: '激活时间',
            align: "center",
            sorter: true,
            dataIndex: 'activatedTime'
          },
          {
            title: '运维权限',
            align: "center",
            sorter: true,
            dataIndex: 'maintenancePermission',
            scopedSlots: { customRender: 'maintenancePermission' }
          },
          {
            title: '禁止取水',
            align: "center",
            sorter: true,
            dataIndex: 'disabled',
            scopedSlots: { customRender: 'disabled' }
          },
          {
            title: '用途',
            align: "left",
            dataIndex: 'purpose'
          },
          {
            title: '合同存档',
            align: "left",
            dataIndex: 'files',
            scopedSlots: { customRender: 'files' }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/wf/wfConsumerCorp/list",
          delete: "/wf/wfConsumerCorp/delete",
          edit: "/wf/wfConsumerCorp/edit",
          initAdmin: "/wf/wfConsumerCorp/initAdmin",
          deleteBatch: "/wf/wfConsumerCorp/deleteBatch",
          exportXlsUrl: "/wf/wfConsumerCorp/exportXls",
          importExcelUrl: "wf/wfConsumerCorp/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.$set(this.dictOptions, 'disabled', [{ text: '是', value: 'Y' }, { text: '否', value: 'N' }])
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      recharge (record) {
        const model = {
          corpId: record.id
        }
        this.$refs.rechargeModalForm.add(model)
        this.$refs.rechargeModalForm.title = `充水量：[${record.corpName}]`
        this.$refs.rechargeModalForm.disableSubmit = false
      },
      authDev (record) {
        this.$refs.modalForm.edit(record, '2')
        this.$refs.modalForm.title = '编辑'
        this.$refs.modalForm.disableSubmit = false
      },
      handleDisabled (id, disabled) {
        putAction(this.url.edit, { id: id, disabled: disabled })
          .then(res => {
            if (res.success) {
              this.$emit('ok')
              this.loadData()
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            this.confirmLoading = false
          })
      },
      handleMaintenancePermission (id, maintenancePermission) {
        putAction(this.url.edit, { id: id, maintenancePermission: maintenancePermission })
          .then(res => {
            if (res.success) {
              this.$emit('ok')
              this.loadData()
            } else {
              that.$message.warning(res.message)
            }
          }).finally(() => {
            this.confirmLoading = false
          })
      },
      initAdmin (record) {
        putAction(this.url.initAdmin, record)
          .then(res => {
            if (res.success) {
              this.$emit('ok')
              this.loadData()
            } else {
              this.$message.warning(res.message)
            }
          }).finally(() => {
            this.confirmLoading = false
          })
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'corpName', text: '企业名称', dictCode: '' })
        fieldList.push({ type: 'string', value: 'contact', text: '联系人', dictCode: '' })
        fieldList.push({ type: 'string', value: 'phone', text: '联系电话', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'contractVolume', text: '合同用水量(吨)', dictCode: '' })
        fieldList.push({ type: 'int', value: 'contractCycle', text: '合同周期', dictCode: '' })
        fieldList.push({ type: 'string', value: 'contractCycleUnit', text: '合同周期单位', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'remainingVolume', text: '剩余可用量', dictCode: '' })
        fieldList.push({ type: 'BigDecimal', value: 'overUsage', text: '允许超用量', dictCode: '' })
        fieldList.push({ type: 'date', value: 'joinTime', text: '加入时间' })
        fieldList.push({ type: 'switch', value: 'disabled', text: '禁止取水' })
        fieldList.push({ type: 'string', value: 'remark', text: '备注', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>